import { EmbarkCart } from 'shopify-buy';
import { CrossIcon } from './icons/CrossIcon';
import React from 'preact/compat';
import { getLineItemsCount } from '../storefront-cart';
interface Props {
  cart: EmbarkCart | null;
  toggleDrawer: () => void;
}
export const DrawerHeader: React.FC<Props> = ({ cart, toggleDrawer }) => {
  return (
    <div className="cart-drawer__header">
      <div className="cart-drawer__header__title">
        <h3 className={'h4'}>
          Your cart (<span>{getLineItemsCount(cart)}</span>
          <span className="sr-only">items in your cart</span>)
        </h3>
      </div>

      <button
        onClick={toggleDrawer}
        className="cart-drawer__header__close"
        aria-label="Close cart"
      >
        <CrossIcon title={'close cart drawer'} ariaHidden={'true'} />
      </button>
    </div>
  );
};
